import __request__ from "routing/request";
export function createClientCert(request) {
  return __request__("POST", "/ca/clientcert", request, {}, {
    "Accept": ["application/json"]
  });
}
export function deleteClientCert(role, principal) {
  return __request__("DELETE", `/ca/clientcert/${role}/${principal}`, null, {}, {
    "Accept": ["application/json"]
  });
}
